import { Injectable } from '@angular/core';
import { RootService } from '@app/core/root.service';
import { ItemProps } from '@app/interfaces';
import { Router } from '@angular/router';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { Validators } from '@angular/forms';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { CustomValidators } from '@app/core/classes/custom-validators/custom-validators';
import { SharedService } from '@app/shared/services/shared.service';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { Observable } from 'rxjs';
import { UsersService } from '@app/users-feature/users.service';

@Injectable({
  providedIn: 'root'
})
export class CommercialDamagedService extends RootService {
  constructor(
    router: Router,
    api: ApiRequestService,
    shared: SharedService,
    permissionsService: PermissionsService,
    private toArabicPipe: ToArabicPipe,
    private usersService: UsersService
  ) {
    super(router, api, permissionsService, shared);
    this.permissionsKey = 'permission';
  }

  routerPrefix(val: string = '') {
    return val ? val : 'commercial-damaged-permissions';
  }

  refactorItem(item: any) {
    return item;
  }
  navigateToList() {
    this.usersService.updateResources.next(null);
    return super.navigateToList();
  }

  refactorSelectListsResponse(listPrefix: string, response: any, listPaginate: boolean = false): any {
    if (listPrefix === 'permission_numbers') {
      // console.log(listPrefix);
      // console.log('demolition_serials');
      // this.loaded.next(true);

      if (response.data && response.data.length) {
        response.data = response.data.map((item: any) => item['serial']);
      }
      // console.log(response.data);
    }
    this.loaded.next(true);

    if (response.data) {
      if (listPaginate) {
        return response;
      } else {
        return response.data;
      }
    }
  }
  refactorFormBeforeSubmit(formValue: any) {
    if (formValue['units'].length > 1) {
      const unitsLength = formValue['units'].length;
      if (!formValue['units'][unitsLength - 1]['plate_number']) {
        formValue['units'].pop();
      }
      formValue['units'].map((unit: any) => {
        unit['qr_code'] = unit['qr_code'] ? +unit['qr_code'] : null;
        unit['rfid'] = unit['rfid'] ? +unit['rfid'] : null;
        return unit;
      });
    }
    if (formValue.permission_date_input) {
      formValue.permission_date = this.shared.dateToCustomFormat(formValue.permission_date_input, 'DD-MM-YYYY');
    }
    // if (formValue.company_commercial_number) {
    //   formValue['company_commercial_number'] = parseInt(formValue.company_commercial_number);
    // }
    if (formValue.national_id) {
      formValue['national_id'] = parseInt(formValue.national_id);
    }
    // if (formValue.permission_number) {
    //   formValue['permission_number'] = parseInt(formValue.permission_number);
    // }
    if (formValue.allowed_weight) {
      formValue['allowed_weight'] = parseInt(formValue.allowed_weight);
    }

    return formValue;
  }

  updateItemAsPost(id: any, data: {}) {
    return this.doUpdateItemAsPost('permissions/commercial/append-units/' + id, data);
  }

  updateItem(id: any, data: {}) {
    return this.doUpdateItem('permissions/commercial/append-units/' + id, data);
  }

  getRequest(url: string) {
    return this.api.request('GET', url, {}, {}, {});
  }

  onChangedValue(column: ItemProps, event: any) {
    super.onChangedValue(column, event);
    if (column.name === 'permission_number' && event) {
      this.loaded.next(false);
      this.getRequest('commercial-damaged-permissions/details/' + event).subscribe(
        (res: any) => {
          if (res.data) {
            const date = res.data['permission_date']
              .split('-')
              .reverse()
              .join('-');
            res.data['permission_date_input'] = date;
            delete res.data['units'];
            this.shared.selectePermission$.next(res.data);
            this.loaded.next(true);
          }
        },
        error => {
          console.log('not found');
          this.shared.selectePermission$.next(null);
          this.loaded.next(true);
        }
      );
    }
  }

  get featureProps(): ItemProps[] {
    return [
      {
        name: 'permission_number',
        prop: 'serial',
        form: {
          Validators: [Validators.required, CustomValidators.numberValidator],
          formFieldType: 'ng_tag_select',
          listPrefix: 'permission_numbers',
          dataUrl: 'permissions/commercial/serials',
          onChange: true,
          numberOnly: true,
          maxLength: 18,
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.permission_tab',
              steps: true
            }
          }
        }
      },
      {
        name: 'permission_date',
        prop: 'permission_date',
        form: {
          formFieldType: 'hidden',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.permission_tab'
            }
          }
        }
      },
      {
        name: 'permission_date_input',
        prop: 'permission_date_input',
        form: {
          Validators: [Validators.required],
          formFieldType: 'datepicker',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.permission_tab'
            }
          }
        }
      },

      {
        name: 'allowed_weight',
        prop: 'allowed_weight',
        form: {
          Validators: [CustomValidators.numberValidator],
          formFieldType: 'float',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.permission_tab'
            }
          }
        }
      },
      {
        name: 'company_name',
        prop: 'company_name',
        form: {
          Validators: [Validators.required, Validators.minLength(3), Validators.maxLength(50)],
          formFieldType: 'text',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.company_tab'
            }
          },
          maxLength: 50,
          minLength: 3
        }
      },
      {
        name: 'company_commercial_number',
        prop: 'company_commercial_number',
        form: {
          Validators: [
            Validators.required,
            CustomValidators.numberValidator,
            Validators.minLength(10),
            Validators.maxLength(10)
          ],
          maxLength: 10,
          minLength: 10,

          formFieldType: 'text_number',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.company_tab'
            }
          }
        }
      },
      {
        name: 'representative_name',
        prop: 'representative_name',
        form: {
          Validators: [Validators.required, Validators.minLength(3), Validators.maxLength(50)],
          formFieldType: 'text',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.company_tab'
            }
          },
          maxLength: 50,
          minLength: 3
        }
      },
      {
        name: 'national_id',
        prop: 'national_id',
        form: {
          Validators: [
            Validators.required,
            Validators.pattern(/^[1-2][\d]+$/),
            Validators.minLength(10),
            Validators.maxLength(10)
          ],
          maxLength: 10,
          minLength: 10,
          formFieldType: 'text_number',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.company_tab'
            }
          }
        }
      },

      {
        name: 'units',
        prop: 'units',
        form: {
          formFieldType: 'formArray',
          name: 'units',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'commercial-damaged-permissions.units'
            }
          },
          arrayForm: [
            {
              name: 'plate_number',
              prop: 'plate_number',
              list: {
                hidden: true
              },
              form: {
                Validators: [Validators.required, Validators.minLength(4), Validators.maxLength(8)],
                formFieldType: 'text',
                maxLength: 8,
                minLength: 4
              }
            },
            {
              name: 'qr_code',
              prop: 'qr_code',
              list: {
                hidden: true
              },
              form: {
                Validators: [Validators.required],
                formFieldType: 'text_number'
              }
            },
            {
              name: 'rfid',
              prop: 'rfid',
              list: {
                hidden: true
              },
              form: {
                Validators: [],
                formFieldType: 'text_number'
              }
            }
          ]
        }
      }
    ];
  }
}
